import connect from "../axios/axios.auth";

const funciones = {
    despachos: () => {
        return new Promise((resolve, reject) => {
            connect.get(`/app/despachos`)
            .then((response) => {
                resolve(response.data);
            })
          })
    } 
}

export default funciones;